import { useState, useEffect } from "react";
import { getData } from '../../utils/apiCalls';
import { tracking } from '../../utils/tracking';
import { Link } from "react-router-dom";
import sponsors_home from '../../data/sopnsors_home.json'

const Image = ({ url }) => {
   return <img src={url} alt="" />;
};

export const SponsorSection = () => {
   const [sponsors, setSponsors] = useState([]);

   useEffect(() => {
      // getData("https://youngstartup.io/api/cwebsite/get_sponsors").then((data) =>
      //    setSponsors(data)
      //    );
      setSponsors(sponsors_home)
   }, []);

   return (
      <div className='sponsors'>
         {sponsors.length > 0 && <h1 >OUR PARTNERS</h1>}
         {sponsors.map((sponsor_type, i) => {
            const { name, values } = sponsor_type;
            return (
               <div className='sponsor' key={i}>
                  <h3>{name.toUpperCase().replace(/_/g, " ")}</h3>
                  <div className='logos'>
                     {values.map(sponsor => (
                        <div key={sponsor.logo_url} className='logo'
                           onClick={() => tracking(282, sponsor.id)}
                        >
                           <a href={sponsor.website} rel='noreferrer' target='_blank'>
                              <Image url={sponsor.logo_url} />
                           </a>
                        </div>
                     ))
                     }
                  </div>
               </div>
            )
         })}
         <div className="btn-container">
            <Link to='/partners' className="btn">Become a partner</Link>
         </div>
      </div>
   );
};
